export default {
  authToken: localStorage.xennAuthToken || '',
  applications: [],
  profile: { user: {}, customer: {} },
  loggedIn: false,
  organizationCustomers: [],
};
